var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col"},[_c('h1',{staticClass:"flex-1 text-center md:text-left text-flamingo-800 text-3xl font-serif"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"flex-1 text-center md:text-left text-gray-400 font-sans"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }